export default "__VITE_ASSET__D3u1cUke__"